import styled from 'styled-components';

export const IndentedMetadataWrapper = styled.div`
  padding: 0 12px;
`;
